/*
 * TemplatePreviewPage Messages
 *
 * This contains all the text for the TemplatePreviewPage container.
 */
import { defineMessages } from 'react-intl';

export const scope = 'app.containers.TemplatePreviewPage.TemplateFlows';

export default defineMessages({
  validation: {
    fieldRequired: {
      id: `${scope}.fieldRequired`,
      defaultMessage: 'This field is required',
    },
    fieldIncomplete: {
      id: `${scope}.fieldIncomplete`,
      defaultMessage: 'There is 1 value missing',
    },
    fieldIncompletePlural: {
      id: `${scope}.fieldRequired`,
      defaultMessage: 'There are {missingValuesCount} values missing.',
    },
    fieldHasExtra: {
      id: `${scope}.fieldHasExtra`,
      defaultMessage: 'Please remove {extraValuesCount} value.',
    },
    fieldHasExtraPlural: {
      id: `${scope}.fieldHasExtra`,
      defaultMessage: 'Please remove {extraValuesCount} values.',
    },
    fieldInvalidNumber: {
      id: `${scope}.fieldInvalidNumber`,
      defaultMessage: 'Please fix invalid number values.',
    },
    fieldHasSubError: {
      id: `${scope}.fieldHasSubError`,
      defaultMessage: 'All fields are required.',
    },
    fieldLimitMin: {
      id: `${scope}.fieldLimitMin`,
      defaultMessage: 'This number must be greater than {limitMin}',
    },
    fieldLimitMax: {
      id: `${scope}.fieldLimitMax`,
      defaultMessage: 'This number must be smaller than {limitMax}',
    },
    fieldNotInteger: {
      id: `${scope}.fieldNotInteger`,
      defaultMessage: 'This number must be an integer',
    },
    vwMin: {
      id: `${scope}.vwMin`,
      defaultMessage: 'The max price must be greater that the min price',
    },
    vwMax: {
      id: `${scope}.vwMax`,
      defaultMessage: 'The min price must be smaller that the max price',
    },
    fieldHasMorePriceTypes: {
      id: `${scope}.fieldHasMorePriceTypes`,
      defaultMessage: 'You can only have one price type attribute.',
    },
  },
  uploadMedia: {
    id: `${scope}.uploadMedia`,
    defaultMessage: 'Add files for you product or service',
  },
});
